import * as types from "../constants/ActionTypes";

const clientusermonitors = (state = [], action) => {
  switch (action.type) {
    case types.ADD_CLIENT_MONITORING:
      return [
        ...state,
        {
          idatendimento: action.idatendimento,
          cliente: action.cliente,
          telefone: action.telefone,
          servico: action.servico,
          datatimeatd: action.datatimeatd,
          menubot: action.menubot,
          criticidade: action.criticidade,
          subservico: action.subservico,
          id: action.id,
          serviceatd: action.serviceatd,
          recuperation: action.recuperation,
          recuperationtime: action.recuperationtime,
          respatendente: action.respatendente,
          respclient: action.respclient,
          direction: action.direction,
          idmidia: action.idmidia,
          timecomplete: action.timecomplete,
          statusagent: action.statusagent,
          line: action.line,
          statusatd: action.statusatd,
          queueid: action.queueid,
          monuser: action.monuser,
          serverid: action.serverid,
          pathfile: action.pathfile,
          isFromStandby: action.isFromStandby,
          qtdmessage: action.qtdmessage,
          score_class: action.score_class,
          score_value: action.score_value,
          serviceAtdId: action.serviceAtdId,
          nomesubservico: action.nomesubservico ? action.nomesubservico : "",
          responsavelPor: action.responsavelPor || [],
          contactId: action.contactId || null,
        },
      ];
    case types.REMOVE_USER_MONITORING:
      return state.filter(
        (client) => parseInt(client.monuser) !== parseInt(action.monuser),
      );
    case types.REMOVE_CLIENT_MONITORING:
      return state.filter(
        (client) => parseInt(client.idatendimento) !== parseInt(action.cdrid),
      );
    case types.EDIT_QTD_MSG_MONITORING:
      return state.map((client) =>
        parseInt(client.idatendimento) === parseInt(action.cdr)
          ? { ...client, qtdmessage: client.qtdmessage + 1 }
          : client,
      );
    case types.EDIT_TOTAL_QTD_MSG_MONITORING:
      return state.map((client) => {
        return parseInt(client.idatendimento) === parseInt(action.cdr)
          ? { ...client, qtdmessage: action.qtdmessage }
          : client;
      });
    case types.CLEAR_QTD_MSG_MONITORING:
      return state.map((client) => {
        return parseInt(client.idatendimento) === parseInt(action.cdr)
          ? { ...client, qtdmessage: 0 }
          : client;
      });
    case types.EDIT_IS_FROM_STANDBY_MONITORING:
      return state.map((client) => {
        return parseInt(client.idatendimento) === parseInt(action.cdr)
          ? { ...client, isFromStandby: action.isFromStandby }
          : client;
      });
    case types.ADD_ENTERPRISE_ADDITIONAL_INFOS:
      return state.map((atd) => {
        return parseInt(atd.idatendimento) === parseInt(action.cdr)
          ? {
              ...atd,
              enterpriseAdditionalInfos: action.enterpriseAdditionalInfos,
            }
          : atd;
      });
    case types.ADD_CONTACT_ADDITIONAL_INFOS:
      return state.map((atd) =>
        parseInt(atd.idatendimento) === parseInt(action.cdr)
          ? {
              ...atd,
              contactAdditionalInfos: action.contactAdditionalInfos,
            }
          : atd,
      );
    case "CHANGE_RESPONSAVEL_POR":
      return state.map((atd) =>
        (Boolean(action.cdr) &&
          parseInt(atd.idatendimento) === parseInt(action.cdr)) ||
        (!isNaN(parseInt(atd.contactId)) &&
          !isNaN(parseInt(action.contactId)) &&
          parseInt(atd.contactId) === action.contactId)
          ? {
              ...atd,
              responsavelPor: action.responsavelPor,
              contactId: action.contactId || atd.contactId,
            }
          : atd,
      );
    case "ADD_BATCH_RESPONSAVEL_POR":
      return state.map((atd) =>
        parseInt(atd.idatendimento) === parseInt(action.cdr)
          ? {
              ...atd,
              responsavelPor: [
                ...action.responsavelPor,
                ...action.listaResponsavelPor,
              ],
            }
          : atd,
      );
    case "REMOVE_COMPANY_OF_RESPONSAVEL_POR":
      return state.map((atd) =>
        parseInt(atd.idatendimento) === parseInt(action.cdr)
          ? {
              ...atd,
              responsavelPor: atd.responsavelPor.filter(
                (empresa) => !action.companysIds.includes(parseInt(empresa.id)),
              ),
            }
          : atd,
      );
    default:
      return state;
  }
};

export default clientusermonitors;
